import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import { HashLink } from "react-router-hash-link";
import DashboardMyReviewsPerPage from "./DashboardMyReviewsPerPage";
import Fade from "react-reveal/Fade";
import {
  db,
  doc,
  getDoc,
  where,
  getDocs,
  query,
  collection,
} from "../../firebase";
import LeftMenu from "./LeftMenu";
import { useTranslation } from "react-i18next";
import Pagination from "@mui/material/Pagination";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles({
  body: { backgroundColor: "white", minHeight: "500px", padding: "50px" },
  title: { fontSize: "17px" },
});

const Dashboard = () => {
  const { t, i18n } = useTranslation();
  const numOfReviews = 2;

  const classes = useStyles();
  const { currentUser } = useAuth();
  const [reviews, setReviews] = useState(null);
  const [foundReviews, setFoundReviews] = useState([]);
  const [progress, setProgress] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    console.log(value);
  };

  useEffect(() => {
    setTimeout(() => {
      setProgress(false);
    }, 500);

    const getReviews = async () => {
      setReviews([]);
      const docRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        let temp = docSnap.data().reviews;

        if (temp) {
          // sort by time desc
          let sorted_students = temp.reverse(function (a, b) {
            return a.created - b.created;
          });

          setReviews(sorted_students);
        }
      } else {
        console.log("No such document!");
      }
    };

    getReviews();
  }, []);

  useEffect(() => {
    const getReviews = async () => {
      const uniqueNames = reviews.filter(
        (val, id, array) => array.indexOf(val) == id
      );
      console.log("uniquReviews", uniqueNames);

      uniqueNames.map(async (dbname) => {
        const q = query(
          collection(db, dbname),
          where("uid", "==", currentUser.uid)
        );

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          setFoundReviews((old) =>
            old.concat({
              ...doc.data(),
              id: doc.id,
              productId: dbname.replace("KO_" + "reviews_", ""),
            })
          );
        });
      });
    };
    if (reviews) {
      setFoundReviews([]);
      getReviews();
    }
  }, [reviews]);

  console.log("foundReviews", foundReviews.length / numOfReviews);
  console.log("foundReviews", foundReviews);
  console.log("currentPage", currentPage);

  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Grid item sm={12} md={12} sx={{ fontSize: "19px", pb: 2, pl: 2 }}>
        <Box>{t("MY ACCOUNT")}</Box>
      </Grid>

      <LeftMenu cursor="review" />
      <Grid
        md={9}
        sm={12}
        className={classes.body}
        sx={{ position: "relative", paddingBottom: "100px" }}
      >
        <Box className={classes.title} sx={{ height: "auto" }}>
          <Box sx={{ fontWeight: 600, fontSize: "17px" }}>
            <Fade delay={300}>{t("Reviews dash")}</Fade>
          </Box>

          <Box>
            {foundReviews.length === 0 ? (
              <>
                <Box
                  sx={{ fontSize: "13px", pt: 3, lineHeight: "1.9em", pb: 2 }}
                >
                  {t(
                    "You have no review yet. You can leave a review after purchasing a product."
                  )}{" "}
                  <br />
                  <HashLink to="/dashboard">
                    <Box className="pink_link">
                      {t("Go to your dashboard to leave a review")}
                    </Box>
                  </HashLink>
                </Box>
              </>
            ) : (
              <DashboardMyReviewsPerPage
                foundReviews={foundReviews.slice(
                  (page - 1) * numOfReviews,
                  numOfReviews * page
                )}
              />
            )}
          </Box>
        </Box>
        {/* <Box
          sx={{
            display: "flex",
            position: "absolute",
            bottom: 50,
          }}
        >
          {Array.apply(null, {
            length: Math.ceil(foundReviews.length / numOfReviews),
          }).map((e, i) => {
            if (currentPage === i) {
              return (
                <Box
                  key={i}
                  sx={{
                    border: "1px solid lightgray",
                    margin: "2px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    py: 1,
                    color: "#153a5a",
                    backgroundColor: "#f5f5f5",
                  }}
                  onClick={(e) => setCurrentPage(i)}
                >
                  {i + 1}
                </Box>
              );
            } else {
              return (
                <Box
                  key={i}
                  sx={{
                    border: "1px solid lightgray",
                    margin: "2px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    py: 1,
                    cursor: "pointer",
                  }}
                  onClick={(e) => setCurrentPage(i)}
                >
                  {i + 1}
                </Box>
              );
            }
          })}
        </Box> */}

        <Pagination
          count={Math.ceil(foundReviews.length / numOfReviews)}
          variant="outlined"
          color="secondary"
          sx={{ my: 2 }}
          onChange={handleChange}
          page={page}
        />
      </Grid>
    </Grid>
  );
};

export default Dashboard;
